import { useEffect, useState } from 'react';
import { s } from '../listPageStyles';
import { MultiChipSelect } from './MultiChipSelect';
import {
  TYPE_OPTIONS, fmtDate, csvToArr, arrToCsv, resolveLabels,
} from './campaignUtils';
import { RELATION_CONFIGS } from '../relationConfigs';

// CSV <-> chip item dizisi köprüsü (distribütör kriteri — çoklu seçim).
function useVendorCsvItems(csv, setCsv) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const ids = csvToArr(csv);
    if (!ids.length) { setItems([]); return; }
    let alive = true;
    resolveLabels('/api/vendors', ids).then((map) => {
      if (alive) setItems(ids.map((id) => ({ value: id, label: map[id] || id })));
    }).catch(() => { if (alive) setItems(ids.map((id) => ({ value: id, label: id }))); });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [csv]);
  const onChange = (next) => { setItems(next); setCsv(arrToCsv(next.map((x) => x.value))); };
  return [items, onChange];
}

export function CampaignGeneralTab({ form, setForm, isEdit }) {
  const set = (patch) => setForm((c) => ({ ...c, ...patch }));
  const inputStyle = isEdit ? s.input : s.inputView;
  const selectStyle = isEdit ? s.select : s.selectView;

  // Distribütör kriteri — çoklu seçim (boş = Tüm Sistem).
  const [distributorItems, setDistributorItems] = useVendorCsvItems(form.distributorIdsCsv, (v) => set({ distributorIdsCsv: v }));

  // #8 — Tip değişince, yeni tipte pasife geçecek ödül alanlarını sıfırla.
  //   İndirim (DISCOUNT_PCT) → bedava miktar sıfırlanır.
  //   Paket / Bedelsiz → indirim % ve sabit indirim sıfırlanır.
  const onTypeChange = (next) => {
    const patch = { type: next };
    if (next === 'DISCOUNT_PCT') patch.freeQty = 0;
    else { patch.discountPct = 0; patch.discountAmount = 0; }
    set(patch);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={s.formRow}>
        <div style={s.formGroup}>
          <label style={s.label}>Promosyon Adı *</label>
          <input style={inputStyle} value={form.name} readOnly={!isEdit} onChange={(e) => set({ name: e.target.value })} placeholder="Kampanya adı" />
        </div>
        <div style={s.formGroup}>
          <label style={s.label}>Kod *</label>
          <input style={inputStyle} value={form.code} readOnly={!isEdit} onChange={(e) => set({ code: e.target.value })} placeholder="CAMP-2026-001" />
        </div>
      </div>

      <div style={s.formGroup}>
        <label style={s.label}>
          Distribütör Kriteri
          {!isEdit && !distributorItems.length && <span style={{ color: 'var(--text-secondary,#6b7280)' }}> (Tüm Sistem)</span>}
        </label>
        <MultiChipSelect
          items={distributorItems}
          onChange={setDistributorItems}
          config={RELATION_CONFIGS.vendor}
          placeholder="Distribütör ara ve ekle… (boş = Tüm Sistem)"
          disabled={!isEdit}
        />
      </div>

      <div style={s.formRow}>
        <div style={s.formGroup}>
          <label style={s.label}>Tip</label>
          {isEdit
            ? <select style={selectStyle} value={form.type} onChange={(e) => onTypeChange(e.target.value)}>{TYPE_OPTIONS.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}</select>
            : <input style={inputStyle} readOnly value={(TYPE_OPTIONS.find((t) => t.value === form.type) || {}).label || form.type} />}
        </div>
        <div style={s.formGroup}>
          <label style={s.label}>Açıklama</label>
          <input style={inputStyle} value={form.shortDescription} readOnly={!isEdit} onChange={(e) => set({ shortDescription: e.target.value })} placeholder="Promosyon açıklaması" />
        </div>
      </div>

      <div style={s.formRow}>
        <div style={s.formGroup}>
          <label style={s.label}>Başlangıç Tarihi</label>
          {isEdit
            ? <input style={inputStyle} type="date" value={form.startDate} onChange={(e) => set({ startDate: e.target.value })} />
            : <input style={inputStyle} readOnly value={form.startDate ? fmtDate(`${form.startDate}T00:00:00`) : '-'} />}
        </div>
        <div style={s.formGroup}>
          <label style={s.label}>Bitiş Tarihi</label>
          {isEdit
            ? <input style={inputStyle} type="date" value={form.endDate} onChange={(e) => set({ endDate: e.target.value })} />
            : <input style={inputStyle} readOnly value={form.endDate ? fmtDate(`${form.endDate}T00:00:00`) : '-'} />}
        </div>
      </div>

      {/* Yönetim — Genel sekmesi bu başlıkla sonlanır */}
      <h4 className="cmp-section-title" style={{ fontSize: 15, marginTop: 8 }}>🗂 Yönetim</h4>
      <div style={s.formGroup}>
        <label style={{ ...s.label, display: 'flex', alignItems: 'center', gap: 8, cursor: isEdit ? 'pointer' : 'default' }}>
          <input type="checkbox" checked={!!form.isActive} disabled={!isEdit} onChange={(e) => set({ isActive: e.target.checked })} />
          Aktif (mobile'da uygulanır)
        </label>
      </div>
      {form.createdBy && (
        <div style={s.formRow}>
          <div style={s.formGroup}>
            <label style={s.label}>Oluşturan</label>
            <input style={s.inputView} readOnly value={form.createdBy || '-'} />
          </div>
          <div style={s.formGroup}>
            <label style={s.label}>Oluşturma Tarihi</label>
            <input style={s.inputView} readOnly value={form.createdDate ? fmtDate(form.createdDate) : '-'} />
          </div>
        </div>
      )}
    </div>
  );
}

export default CampaignGeneralTab;
